import gql from "graphql-tag"

const GET_DISCOUNT_CODE_RULE = gql`
  query getDiscountCodeRule($id: ID!) {
    getDiscountCodeRule(id: $id) {
      id
      name
      logicRules {
        if
        do
      }
      isActive
      isStackable
      isExclusive
      applyLast
      sortOrder
      conditions {
        type
        id
        triggerQuantity
        identifiers
        thresholds {
          currencyCode
          units
        }
        itemRule {
          tagConditions {
            mode
            key
            values
          }
          excludeDiscountedPrices
          excludeFullPrices
        }
      }
      outcomes {
        type
        id
        subOutcomes {
          triggerQuantity
          discountQuantity
          discountValue {
            type
            percentage
            fixedDiscounts {
              currencyCode
              units
            }
          }
        }
        discountValue {
          type
          percentage
          fixedDiscounts {
            currencyCode
            units
          }
        }
        discountItemRule {
          tagConditions {
            mode
            key
            values
          }
          excludeDiscountedPrices
          excludeFullPrices
        }
        triggerItemRule {
          tagConditions {
            mode
            key
            values
          }
          excludeDiscountedPrices
          excludeFullPrices
        }
        shippingTags
        triggerQuantity
        discountQuantity
        gifts {
          productVariantId
          quantity
        }
        combineItemDiscount
        isRecurrent
      }
      validDateRange {
        from
        to
      }
    }
  }
`

export default GET_DISCOUNT_CODE_RULE
